const appKey = "annual2022"
const cdnUrl = "https://site.gcores.com"

const shareTitle = "来看看我的机核 2022 年度总结"
const shareDesc = "这一年辛苦了"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: shareTitle,
    description: shareDesc,
    shareTitle,
    shareDescription: shareDesc,
  },
  pageDelay: 800,
  pageTotalDuration: 1400,

  redColor: "#fe0045",
  whiteColor: "#ffffff",
}
